import { Form, Select } from 'antd'
import { FormItemProps } from 'antd/lib'
import { useTranslation } from 'react-i18next'
import { cloneElement, ReactElement, ReactNode } from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'

interface Props extends FormItemProps {
  name: string
  label?: ReactNode
  loading?: boolean
  errors: FieldErrors
  control: Control<any> //eslint-disable-line
  errorMessage?: string
  secondaryLabel?: string
  component: ReactElement
  disabled?: boolean
}

function FormItem({
  name,
  label,
  errors,
  control,
  loading,
  component,
  errorMessage,
  secondaryLabel,
  disabled,
  ...props
}: Props) {
  const { i18n } = useTranslation()

  return (
    <Form.Item
      label={label}
      className="min-w-[230px]"
      validateStatus={errors[name] ? 'error' : ''}
      help={
        errorMessage
          ? errorMessage
          : errors[name]
            ? i18n.t(`form.error.${errors[name]?.message}`)
            : ''
      }
      {...props}
    >
      {loading ? (
        <Select
          loading
          disabled
          size="large"
          placeholder={i18n.t('action.select')}
        />
      ) : (
        <Controller
          name={name}
          control={control}
          disabled={disabled}
          render={({ field }) => (
            <>
              {cloneElement(component, {
                ...field,
              })}
              {secondaryLabel && (
                <span style={{ marginLeft: 10 }}>{secondaryLabel}</span>
              )}
            </>
          )}
        />
      )}
    </Form.Item>
  )
}

export default FormItem
